import React from 'react'
// components
import ActionButton from './ActionButton'
import { PopoverModal } from 'components/UI'
// context
import { ObjectivesListTreeBLContext } from 'containers/ObjectivesList/layers/BL/Tree'
// constants
import { ENTITIES } from 'constants/index'
// types
import { IPlanTypeLevelOption } from 'types/graphql'
import { ITableTreeNode } from 'components/UI/TableTree/types'
// views
import { ActionIcon, AddIcon, MeasureIcon, MenuItem, MenuWrapper, ObjectiveIcon } from './views'

interface IProps {
  node: ITableTreeNode
  levelOptions: IPlanTypeLevelOption[]
  nextLevelDescription: string
  shouldShowAddObjectiveButton: boolean
  shouldShowAddActionButton: boolean
  shouldShowAddKPIButton: boolean
}

const AddMenu: React.FC<IProps> = ({
  node,
  levelOptions,
  nextLevelDescription,
  shouldShowAddObjectiveButton,
  shouldShowAddActionButton,
  shouldShowAddKPIButton
}) => {
  const { openTableCreateForm } = React.useContext(ObjectivesListTreeBLContext)

  return (
    <PopoverModal
      trigger={
        <ActionButton description='Add Item'>
          <AddIcon />
        </ActionButton>
      }>
      {({ closePopup }) => {
        const addObjective = (typeOption?: IPlanTypeLevelOption) => (event: React.MouseEvent) => {
          openTableCreateForm(ENTITIES.PLAN_OBJECTIVE, node, typeOption)
          closePopup(event)
        }

        const addAction = (event: React.MouseEvent) => {
          openTableCreateForm(ENTITIES.PLAN_ACTION, node)
          closePopup(event)
        }

        const addKPI = (event: React.MouseEvent) => {
          openTableCreateForm(ENTITIES.PLAN_KPI, node)
          closePopup(event)
        }

        return (
          <MenuWrapper>
            {shouldShowAddObjectiveButton && (
              <>
                <MenuItem onClick={addObjective()}>
                  <ObjectiveIcon />
                  {nextLevelDescription}
                </MenuItem>
                {levelOptions.map((typeOption) => (
                  <MenuItem key={typeOption.id} onClick={addObjective(typeOption)}>
                    <ObjectiveIcon />
                    {typeOption.label}
                  </MenuItem>
                ))}
              </>
            )}
            {shouldShowAddActionButton && (
              <MenuItem onClick={addAction}>
                <ActionIcon />
                Action
              </MenuItem>
            )}
            {shouldShowAddKPIButton && (
              <MenuItem onClick={addKPI}>
                <MeasureIcon />
                Indicator
              </MenuItem>
            )}
          </MenuWrapper>
        )
      }}
    </PopoverModal>
  )
}

export default AddMenu
